'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  base: {
    padding: 20,
    paddingTop: 0,
    paddingBottom: 0,
    margin: '0 auto'
  },
  big: {
    maxWidth: 1200
  },
  small: {
    maxWidth: 600
  },
  medium: {
    maxWidth: 900
  }
};

var Container = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Container, _React$Component);

  function Container() {
    (0, _classCallCheck3.default)(this, Container);
    return (0, _possibleConstructorReturn3.default)(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  (0, _createClass3.default)(Container, [{
    key: 'getStyle',
    value: function getStyle() {
      return (0, _extends3.default)({}, styles.base, styles[this.props.size], this.props.style);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: this.getStyle() },
        this.props.children
      );
    }
  }]);
  return Container;
}(_react2.default.Component), _class.propTypes = {
  children: _propTypes2.default.any,
  style: _propTypes2.default.object,
  size: _propTypes2.default.string
}, _class.defaultProps = {
  size: 'big'
}, _temp);
exports.default = Container;


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/components/Container/index.js
// module id = 628
// module chunks = 0